module.exports = __webpack_public_path__ + "static/media/heppy.f7a4db44.png";